<template>
  <div class="app-layout">
    <aside class="app-sidebar" :class="{ 'is-collapsed': sidebarCollapsed }">
      <div class="app-sidebar__logo">
        <span v-if="!sidebarCollapsed" class="app-sidebar__logo-text">辉耀</span>
        <span v-else class="app-sidebar__logo-mini">辉</span>
      </div>
      <el-menu
        :default-active="activeMenuPath"
        router
        mode="vertical"
        :collapse="sidebarCollapsed"
        unique-opened
        class="app-sidebar__menu"
      >
        <template v-for="item in menu">
          <el-submenu
            v-if="!item.leaf"
            :index="item.key"
            :key="`menu-sub-${item.key}`"
          >
            <template slot="title">
              <i :class="menuIcon(item.key)"></i>
              <span>{{ item.name }}</span>
            </template>
            <template v-if="item.children">
              <el-menu-item
                v-for="child in item.children"
                :key="child.path"
                :index="child.path"
              >
                <span>{{ child.name }}</span>
              </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item
            v-else
            :index="item.path"
            :key="`menu-item-${item.key}`"
          >
            <i :class="menuIcon(item.key)"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </aside>

    <section class="app-main">
      <header class="app-topbar">
        <div class="app-topbar__left">
          <button
            type="button"
            class="app-topbar__toggle"
            @click="toggleSidebar"
          >
            <i :class="sidebarCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
          </button>
          <div class="app-topbar__breadcrumb">
            <span class="app-topbar__breadcrumb-label">当前位置</span>
            <span class="app-topbar__breadcrumb-text">{{ breadcrumb() }}</span>
          </div>
        </div>
        <div class="app-topbar__user">
          <el-dropdown @command="handleCommand">
            <span class="app-topbar__user-trigger">
              <el-tag size="small" type="info">{{ user.u_name }}({{ user.u_account }})</el-tag>
              <el-tag size="small">{{ matchUserLevelLabel(user.u_level) }}</el-tag>
              <i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="CHANGE_PASSWORD">修改密码</el-dropdown-item>
              <el-dropdown-item command="LOGOUT" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>

      <main class="app-content">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </main>

      <el-dialog :visible.sync="changePasswordDialog" title="修改密码" width="420px">
        <el-form label-width="80px" label-position="left" size="small">
          <el-form-item label="旧密码">
            <el-input v-model="oldPassword" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model="newPassword" type="password" show-password></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button size="small" @click="changePasswordDialog = false">取消</el-button>
          <el-button size="small" type="primary" @click="onChangePassword()">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </div>
</template>
<script>
import index from './index.js';

export default index;
</script>
<style scoped lang="less">
@import 'index';
</style>
